import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { DateTime } from 'luxon';
import { useEffect, useRef, useState } from 'react';
import { DateRange } from 'react-date-range';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

const PREFIX = 'DateRangeComp';

const classes = {
  button: `${PREFIX}-button`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.button}`]: {
    '&.MuiButton-contained.MuiButton-containedSecondary': {
      borderRadius: '5px',
      '&:hover': {
        backgroundColor: 'white',
        color: 'black',
        border: '1px solid black'
      }
    }
  }
}));

const DateRangeComp = (props) => {
  // date state
  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    }
  ]);

  const [open, setOpen] = useState(true);
  const refOne = useRef(null);
  const refTwo = useRef(null);

  // hide dropdown on ESC press
  const hideOnEscape = (e) => {
    if (e.key === 'Escape') {
      setOpen(false);
      props.setOpen(false);
    }
  };

  // Hide on outside click
  const hideOnClickOutside = (e) => {
    if (refTwo.current && refTwo.current.contains(e.target)) {
      setOpen(false);
      props.setOpen(false);
      props.DownloadFile(
        DateTime.fromJSDate(range[0].startDate).startOf('day').toFormat('yyyy-MM-dd HH:mm:ss'),
        DateTime.fromJSDate(range[0].endDate).endOf('day').toFormat('yyyy-MM-dd HH:mm:ss')
      );
    } else if (refOne.current && !refOne.current.contains(e.target)) {
      setOpen(false);
      props.setOpen(false);
    }
  };

  useEffect(() => {
    // event listeners
    document.addEventListener('keydown', hideOnEscape, true);
    document.addEventListener('click', hideOnClickOutside, true);
    return () => {
      document.removeEventListener('keydown', hideOnEscape, true);
      document.removeEventListener('click', hideOnClickOutside, true);
    };
  }, [range]);

  return (
    <Root>
      {open && (
        <div className="calendarWrap">
          <div ref={refOne}>
            <DateRange
              className="myDatePicker"
              onChange={(item) => {
                setRange([item.selection]);
              }}
              editableDateInputs={true}
              moveRangeOnFirstSelection={false}
              ranges={range}
              months={1}
              maxDate={
                DateTime.fromJSDate(range[0].startDate).plus({ months: 6 }).toJSDate() > new Date()
                  ? new Date()
                  : DateTime.fromJSDate(range[0].startDate).plus({ months: 6 }).toJSDate()
              }
              direction="horizontal"
            />
          </div>
          <div ref={refTwo}>
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              fullWidth
              onClick={() => setOpen(true)}
            >
              Export
            </Button>
          </div>
        </div>
      )}
    </Root>
  );
};

export default DateRangeComp;
